<div class="grid">
  <div class="grid__box grid__box--size-min">
    <div class="grid grid--va-middle">
      <div class="grid__box grid__box--size-min">
        <span class="title">Сотрудники</span>
      </div>
      <div class="grid__box grid__box--size-min">
        <div *ngIf="filter.data && filter.data.working === 0">
          <span class="color-blue-dark"> На смене ({{ filter.data && filter.data.working }}) </span>
        </div>
        <div *ngIf="filter.data && filter.data.working > 0">
          <span class="color-blue-dark font-weight-bold" *ngIf="filter.filterType === 'working'"> На смене ({{ filter.data && filter.data.working }}) </span>
          <a class="link link--dotted-blue-dark" (click)="filter.onSetFilter('working')" *ngIf="filter.filterType !== 'working'">
            На смене ({{ filter.data && filter.data.working }})
          </a>
        </div>
      </div>
      <div class="grid__box grid__box--size-min">
        <div *ngIf="filter.data && filter.data.planned === 0">
          <span class="color-blue-dark"> В плане ({{ filter.data && filter.data.planned }}) </span>
        </div>
        <div *ngIf="filter.data && filter.data.planned > 0">
          <span class="color-blue-dark font-weight-bold" *ngIf="filter.filterType === 'planned'"> В плане ({{ filter.data && filter.data.planned }}) </span>
          <a class="link link--dotted-blue-dark" (click)="filter.onSetFilter('planned')" *ngIf="filter.filterType !== 'planned'">
            В плане ({{ filter.data && filter.data.planned }})
          </a>
        </div>
      </div>
      <div class="grid__box grid__box--size-min">
        <div *ngIf="filter.data && filter.data.action_required === 0">
          <span class="color-blue-dark"> Требуют действий ({{ filter.data && filter.data.action_required }}) </span>
        </div>
        <div *ngIf="filter.data && filter.data.action_required > 0">
          <span class="color-red-dark font-weight-bold" *ngIf="filter.filterType === 'action_required'"> Требуют действий ({{ filter.data && filter.data.action_required }}) </span>
          <a class="link link--dotted-red-dark" (click)="filter.onSetFilter('action_required')" *ngIf="filter.filterType !== 'action_required'">
            Требуют действий ({{ filter.data && filter.data.action_required }})
          </a>
        </div>
      </div>
      <div class="grid__box grid__box--size-min">
        <div *ngIf="filter.data && filter.data.all === 0">
          <span class="color-blue-dark"> Показать всех ({{ filter.data && filter.data.all }}) </span>
        </div>
        <div *ngIf="filter.data && filter.data.all > 0">
          <span class="color-blue-dark font-weight-bold" *ngIf="filter.filterType === 'all'"> Показать всех ({{ filter.data && filter.data.all }}) </span>
          <a class="link link--dotted-blue-dark" (click)="filter.onSetFilter('all')" *ngIf="filter.filterType !== 'all'"> Показать всех ({{ filter.data && filter.data.all }}) </a>
        </div>
      </div>
      <div class="grid__box grid__box--size-min">
        <div class="vertical-separate"></div>
      </div>
      <div class="grid__box grid__box--size-min">
        <span class="title">Смена</span>
      </div>
      <div class="grid__box grid__box--size-min">
        <a *ngIf="!filter.isCurrentDay" class="link link--dotted-blue-dark" (click)="filter.onSetCurrentDate()">Сегодня</a>
        <span *ngIf="filter.isCurrentDay" class="font-weight-bold color-blue-dark">Сегодня</span>
      </div>
      <div class="grid__box grid__box--size-min">
        <div class="field__datepicker field__datepicker--center" ngbDropdown>
          <div class="grid grid--va-middle grid--gap-8">
            <div class="grid__box grid__box--size-min pt-4">
              <button class="ctrl" type="button" id="appPreviewScheduleDate" (click)="filter.onWorkShiftPreviewDateChange()">
                <app-icon [glyph]="'arrow-left'" [size]="'12'" [color]="'gray-dark'"></app-icon>
              </button>
            </div>
            <div class="grid__box grid__box--size-min" style="width: 135px; text-align: center">
              <button class="ctrl link link--dotted-blue-dark" id="appOpenScheduleCalendar" ngbDropdownToggle>
                {{ filter.calendar.selectedDate | dateFormat: 'DD MMMM YYYY' }}
              </button>
            </div>
            <div class="grid__box grid__box--size-min pt-4">
              <button class="ctrl" type="button" id="appNextScheduleDate" (click)="filter.onWorkShiftNextDateChange()">
                <app-icon [glyph]="'arrow-right'" [size]="'12'" [color]="'gray-dark'"></app-icon>
              </button>
            </div>
          </div>
          <div ngbDropdownMenu class="datepicker-month">
            <app-date-picker
              [startView]="'day'"
              [maxView]="'year'"
              [minView]="'day'"
              [(ngModel)]="filter.calendar.initDate"
              (change)="filter.onWorkShiftDateChange($event)"
            ></app-date-picker>
            <div class="grid grid--gap-0 ml-8 mr-8 mb-8 pl-4 pr-4">
              <div class="grid__box grid__box--size-min">
                <span class="link link--dotted-gray-dark" (click)="filter.onSetCurrentDate()">Сейчас</span>
              </div>
              <div class="grid__box grid__box--size-min grid__box--pull-right">
                <span class="link link--dotted-gray-dark" ngbDropdownToggle>Закрыть</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="grid__box grid__box--size-min grid__box--pull-right grid__box--flex grid__box--justify-content-flex-end">
    <div class="grid grid--va-middle">
      <div class="grid__box grid__box--size-min">
        <app-field>
          <content-prefix>
            <div class="field__input-prefix">
              <app-icon [glyph]="'search'" [size]="'16'" [color]="'gray-dark'"></app-icon>
            </div>
          </content-prefix>
          <input type="text" class="input-text input--prefix" id="fullName" [(ngModel)]="filter.full_name" placeholder="Искать по сотрудникам" />
        </app-field>
      </div>
      <div class="grid__box grid__box--size-min">
        <button type="button" class="button" id="appSearchCollaboratorsSchedule" (click)="filter.onSearchUsers()">Искать</button>
      </div>
      <div class="grid__box grid__box--size-min">
        <button type="button" class="ctrl link link--dotted-gray-dark" id="appResetSearchCollaboratorsSchedule" (click)="filter.onResetName()">Сбросить</button>
      </div>
    </div>
  </div>
</div>
<div class="grid">
  <div class="grid__box grid__box--size-min grid__box--pull-right">
    <a class="link link--dotted-gray-dark" [ngbPopover]="LegendPopContent" placement="bottom-right" #p2="ngbPopover"> Легенда </a>
  </div>
</div>

<ng-template #LegendPopContent>
  <div class="grid grid--va-middle grid--gap-8 mt-2 mb-2">
    <div class="grid__box grid__box--size-min">
      <div class="interval-square interval-square--work-day"></div>
    </div>
    <div class="grid__box grid__box--size-min">Рабочий график сотрудника</div>
  </div>
  <div class="grid grid--va-middle grid--gap-8 mt-2 mb-2">
    <div class="grid__box grid__box--size-min">
      <div class="interval-square interval-square--work-time"></div>
    </div>
    <div class="grid__box grid__box--size-min">Рабочее время</div>
  </div>
  <div class="grid grid--va-middle grid--gap-8 mt-2 mb-2">
    <div class="grid__box grid__box--size-min">
      <div class="interval-square interval-square--lunch-time"></div>
    </div>
    <div class="grid__box grid__box--size-min">Перерыв</div>
  </div>
  <div class="grid grid--va-middle grid--gap-8 mt-2 mb-2">
    <div class="grid__box grid__box--size-min">
      <div class="interval-square interval-square--expiration-time"></div>
    </div>
    <div class="grid__box grid__box--size-min">Просрочено / Требуют действий</div>
  </div>
</ng-template>
